import { render, staticRenderFns } from "./inspect-form-select.vue?vue&type=template&id=50af6e3a&"
import script from "./inspect-form-select.vue?vue&type=script&lang=js&"
export * from "./inspect-form-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports